import * as amplitude from '@amplitude/analytics-browser';
const isProd = process.env.ENVIRONMENT_NAME === 'prod';
const developmentApiKey = '75cac0c2957fbf5cdfba999a3646d599';
const productionApiKey = '3f73cc0d58d72664775ae94ebe7df335';
const key = isProd ? productionApiKey : developmentApiKey;
export const amplitudeInit = () => {
  const options = {
    appVersion: '0.0.1',
    // `autocapture` replaces the deprecated `defaultTracking` (Browser SDK v2).
    // `elementInteractions: true` auto-captures clicks/changes on DOM elements;
    // the rest is kept as the previous config (only sessions).
    autocapture: {
      sessions: true,
      formInteractions: false,
      pageViews: false,
      attribution: false,
      fileDownloads: false,
      elementInteractions: true
    }
  };
  amplitude.init(key, options);
};
export const track = (event, properties) => {
  amplitude.track(event, properties);
};
export const accepted = checkboxTitle => "".concat(checkboxTitle, " Accepted");
export const refused = checkboxTitle => "".concat(checkboxTitle, " Refused");
export const filled = inputTitle => "".concat(inputTitle, " Filled");
export const clicked = buttonTitle => "".concat(buttonTitle, " Clicked");
export const created = gistTitle => "".concat(gistTitle, " Created");
export const modalOpened = modalTitle => "".concat(modalTitle, " Modal Opened");
export const modalClosed = modalTitle => "".concat(modalTitle, " Modal Closed");
export const selected = optionTitle => "".concat(optionTitle, " Selected");
export const toggled = toggledOptionTitle => "".concat(toggledOptionTitle, " Toggled");
export const enabled = radioTitle => "".concat(radioTitle, " Enabled");
export const disabled = radioTitle => "".concat(radioTitle, " Disabled");
export const emptied = inputTitle => "".concat(inputTitle, " Emptied");
export const started = title => "".concat(title, " Started");
export const finished = title => "".concat(title, " Finished");
export const skipped = title => "".concat(title, " Skipped");
export const changed = title => "".concat(title, " Changed");
export const datePicked = dateTitle => "".concat(dateTitle, " Date Picked");
export const fileUploaded = fileTitle => "".concat(fileTitle, " File Uploaded");
export const fileRemoved = fileTitle => "".concat(fileTitle, " File Removed");
export const tabNavigated = () => 'Tab Navigated';
export const pageNavigated = () => 'Page Navigated';
export const signedUp = () => 'New User Signed Up';
export const loggedIn = () => 'User Logged In';
export const loggedOut = () => 'User Logged Out';
export const events = {
  accepted,
  refused,
  filled,
  clicked,
  selected,
  toggled,
  created,
  emptied,
  enabled,
  disabled,
  modalOpened,
  modalClosed,
  started,
  finished,
  skipped,
  changed,
  datePicked,
  fileUploaded,
  fileRemoved,
  tabNavigated,
  pageNavigated,
  signedUp,
  loggedIn,
  loggedOut
};